import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

/**
 * The app's dayjs, with every plugin it uses already registered. Import from here rather than from
 * `dayjs` directly.
 *
 * Registration is global, so a module that calls `.fromNow()` or `.tz()` works only because some
 * other module happened to extend first. That is invisible until the module that did the extending
 * stops being imported, and then it fails at runtime with nothing to catch it at build time.
 */
// timezone depends on utc, so both have to be here even if only `.tz()` is called.
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(duration)

export default dayjs
